<button type="button" class="addButton" (click)="addRuleModule()">
  {{'campaign.add_component' | translate}}
</button>
<div class="rule-modules-container">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div formArrayName="rules">
      <div *ngFor="let group of rules.controls; let i = index" [formGroupName]="i" class="rule-section">
        
        <!-- 1) Dropdown Rule Type -->
        <label>{{'campaign.rule_type' | translate}}</label>
        <select formControlName="ruleTypeId" 
                (change)="onRuleTypeChange(i)"
                [class]="getFieldErrorClass(i, 'ruleTypeId')">
          <option [ngValue]="null" disabled>{{'campaign.select_option' | translate}}</option>
          <option *ngFor="let rd of rulesData" [ngValue]="rd.messageInstanceRuleTypeId">
            {{ rd.messageInstanceRuleType }}
          </option>
        </select>
        
        <!-- ✅ Mostra errori Rule Type -->
        <div *ngIf="hasFieldError(i, 'ruleTypeId')" class="error-messages">
          <div *ngFor="let error of getFieldErrors(i, 'ruleTypeId')" class="error-message">
            {{ error }}
          </div>
        </div>
        <!-- Info maxNumOptions per il rule type selezionato -->
        <small class="hint">{{ getSelectionProgressLabel(i) }}</small>
        
        <!-- 2) Dropdown Object Type -->
        <label>{{'campaign.object_type' | translate}}</label>
        <select formControlName="objectTypeId" 
                [disabled]="isObjectTypeDisabled(i)" 
                (change)="onObjectTypeChange(i)"
                [class]="getFieldErrorClass(i, 'objectTypeId')">
          <option [ngValue]="null" disabled>- {{'campaign.select_option' | translate}} -</option>
          <option *ngFor="let obj of getAvailableObjectTypesAt(i)" [ngValue]="obj.messageInstanceObjectTypeId">
            {{ obj.description }}
          </option>
        </select>
        
        <!-- ✅ Mostra errori Object Type -->
        <div *ngIf="hasFieldError(i, 'objectTypeId')" class="error-messages">
          <div *ngFor="let error of getFieldErrors(i, 'objectTypeId')" class="error-message">
            {{ error }}
          </div>
        </div>
        
        <!-- 3) Input valore -->
        <label>{{'campaign.value' | translate}}</label>
        <input pInputText 
               [attr.type]="getInputType(i)" 
               formControlName="inputValue" 
               [attr.max]="getMax(i)"
               [attr.min]="getMin(i)"
               [attr.disabled]="isInputDisabled(i) ? true : null"
               [class]="getFieldErrorClass(i, 'inputValue')" />
        
        <!-- ✅ Mostra errori Input Value -->
        <div *ngIf="hasFieldError(i, 'inputValue')" class="error-messages">
          <div *ngFor="let error of getFieldErrors(i, 'inputValue')" class="error-message">
            {{ error }}
          </div>
        </div>
        
        <button type="button" (click)="removeRuleModule(i)">{{'campaign.remove' | translate}}</button>
      </div>
    </div>
    <button class="addButton" type="submit">{{'campaign.save' | translate}}</button>
  </form>
</div>


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/touchpoint-rule-popup/touchpoint-rule-popup.component.html